function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconProductsMediumOutline = function IconProductsMediumOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 5v8h4V5H5zm6 4.9V13h3.1L11 9.9zm0-3.314l3.293-3.293a1 1 0 011.414 0l4.243 4.243a1 1 0 010 1.414L15.9 13H19a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4c0-.364.097-.706.268-1A1.99 1.99 0 013 13V5a2 2 0 012-2h4a2 2 0 012 2v1.586zM5 15v4h14v-4H5zm7.172-6.757L15 11.07l2.828-2.828L15 5.414l-2.828 2.829z"
  }));
};

export default IconProductsMediumOutline;